"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCatalogTexnosLayout = void 0;
var react_1 = __importDefault(require("react"));
var carCatalogEditDimensions_1 = require("../carCatalogEditDimensions/carCatalogEditDimensions");
var carCatalogEditEngines_1 = require("../carCatalogEditEngines/carCatalogEditEngines");
var typography_1 = __importDefault(require("antd/es/typography"));
var Title = typography_1.default.Title;
var CarCatalogTexnosLayout = function () {
    return (react_1.default.createElement("div", { style: { padding: '20px' } },
        react_1.default.createElement(Title, { level: 1, style: { marginBottom: '20px' } }, "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438"),
        react_1.default.createElement(carCatalogEditDimensions_1.CarCatalogEditDimensions, null),
        react_1.default.createElement(carCatalogEditEngines_1.CarCatalogEditEngines, null)));
};
exports.CarCatalogTexnosLayout = CarCatalogTexnosLayout;
